import React from 'react';

import SystemMessage from './SystemMessage';

import { Link } from 'libs/router';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./system-message.i18n.json'));

import type { Campaign, Deliverable, Subcampaign } from 'types';

type Metadata = {
  campaign?: Campaign,
  subcampaign?: Subcampaign,
  deliverable?: Deliverable,
  creatorName: string,
  reminderDays: number
};

type Props = {
  metadata: Metadata
};

class CcmSystemChatMessageFirstContentReminder extends SystemMessage<Props> {
  render(): React.ReactNode {
    const {
      campaign,
      subcampaign,
      deliverable,
      creatorName,
      reminderDays
    } = this.props.metadata;

    const taskRoute = `/campaigns/${campaign?.id}/subcampaigns/${subcampaign?.id}#deliverable-${deliverable?.id}`;

    return (
      <React.Fragment>
        {this.renderIcon('bell-straight-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div
            className="messages-system-message__bubble"
          >
            <div className="messages-system-message__heading">
              {__t('system_message.ccm_content_reminder', { creatorName, reminderDays })}
            </div>
            <div className="messages-system-message__brief">
              <Link
                to={taskRoute}
                className="messages-system-message__link"
              >
                {__t('system_message.button_messenger_view_task')}
              </Link>
            </div>
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default CcmSystemChatMessageFirstContentReminder;
